export const CompensationIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="56"
            height="56"
            viewBox="0 0 56 56"
            fill="none"
        >
            <path
                fill="#73A5D8"
                d="M33.407 33.051c2.771-.037 5.468.62 7.836 1.82l-.957 1.755a14.832 14.832 0 0 0-6.852-1.575 69.062 69.062 0 0 1-1.868 0c-7.51-.1-14.066 5.484-14.066 12.536 0 .737.666 1.295 1.392 1.166l9.006-1.613a26.116 26.116 0 0 1 9.204 0l9.006 1.613a1.184 1.184 0 0 0 1.392-1.166c0-1.379-.252-2.702-.712-3.937l1.741-1.063c.624 1.544.971 3.224.971 5a3.184 3.184 0 0 1-3.562 3.162l-.182-.028-9.006-1.612a24.119 24.119 0 0 0-8.5 0l-9.006 1.612-.183.028a3.184 3.184 0 0 1-3.561-3.162c0-8.39 7.703-14.649 16.093-14.536l.907.007.907-.007Z"
            />
            <path
                fill="#73A5D8"
                fillRule="evenodd"
                d="M32.5 13.391a9 9 0 1 1 0 18 9 9 0 0 1 0-18Zm0 2a7 7 0 1 0 0 14 7 7 0 0 0 0-14Z"
                clipRule="evenodd"
            />
        </svg>
    );
};
